import { render, staticRenderFns } from "./goodsPayment.vue?vue&type=template&id=2781bec0&scoped=true"
import script from "./goodsPayment.vue?vue&type=script&lang=js"
export * from "./goodsPayment.vue?vue&type=script&lang=js"
import style0 from "./goodsPayment.vue?vue&type=style&index=0&id=2781bec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781bec0",
  null
  
)

export default component.exports